import { render, staticRenderFns } from "./RevisionPreview.vue?vue&type=template&id=581dbb13&scoped=true&"
import script from "./RevisionPreview.vue?vue&type=script&lang=js&"
export * from "./RevisionPreview.vue?vue&type=script&lang=js&"
import style0 from "./RevisionPreview.vue?vue&type=style&index=0&id=581dbb13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581dbb13",
  null
  
)

export default component.exports